import { render, staticRenderFns } from "./QuotationsServices.vue?vue&type=template&id=66a3b558&"
import script from "./QuotationsServices.vue?vue&type=script&lang=js&"
export * from "./QuotationsServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports